import { types } from 'mobx-state-tree';
import { ProductType } from '../types/ProductTypeClass';

const CartProduct = types
  .model('CartProduct', {
    category_name: types.maybeNull(types.string),
    final_unit_price: types.number,
    id: types.string,
    image: types.maybeNull(types.string),
    name: types.string,
    package_size: types.maybeNull(types.number),
    product_id: types.string,
    quantity: types.number,
    short_description: types.maybeNull(types.string),
    starting_unit_price: types.number,
    stock_unit: types.maybeNull(types.string),
    total_price: types.number,
    type: ProductType,
    variations: types.maybeNull(types.array(types.string))
  })
  .preProcessSnapshot(({ quantity, ...rest }) => ({
    quantity: Number(quantity),
    ...rest
  }));

export default CartProduct;



// WEBPACK FOOTER //
// ./src/models/CartProduct.js